import React from 'react';
import ReactModal from 'react-modal';
import {
  ButtonsContainer,
  Content,
  DiscardButton,
  Header,
  ModalStyle,
  OverlayStyle,
  SaveButton,
  Text,
} from './UnsavedChangesModal.styles';
import { Text18Bold } from '../../utils/Text/Text.styles';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';

const UnsavedChangesModal = ({ show, setShow, onDiscard, onSave }) => {
  return (
    <ReactModal
      isOpen={show}
      closeTimeoutMS={300}
      onRequestClose={() => setShow(false)}
      className="_"
      overlayClassName="_"
      contentElement={props => (
        <ModalStyle {...props}>
          <Header>
            <Text18Bold>Unsaved Changes</Text18Bold>
            <CloseIcon onClick={() => setShow(false)} />
          </Header>
          <Content>
            <Text>You have unsaved changes in your gallery.</Text>
            <Text>Do you want to save them before leaving?</Text>
          </Content>
          <ButtonsContainer>
            <DiscardButton title="Discard and Leave" onClick={onDiscard} />
            <SaveButton title="Save and Continue" onClick={onSave} />
          </ButtonsContainer>
        </ModalStyle>
      )}
      overlayElement={(props, contentElement) => <OverlayStyle {...props}>{contentElement}</OverlayStyle>}
      shouldCloseOnEsc={false}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
    />
  );
};

export default UnsavedChangesModal;
